import axios from 'axios';

import { SiteSettingsFeatures } from 'views/site-settings/types/site-settings-features.type';
import { Site, SitesOverviewList } from 'views/site-settings/types/site.type';
import { SiteSettings } from 'views/site-settings/types/site-settings-type';
import { siteSettingsOverviewMock } from 'views/site-settings/mock/site-settings-overview.mock';
import { isProductionEnvironment, isStageEnvironment } from 'utils/environment';

// GET
// /ewosapi/v1/site-settings/{globalCompanyId}/sites-status
// Get a list of site settings for all sites within a company. Warning: expensive, long load times
export const getAllSitesFeatures = async (globalCompanyId: string): Promise<SiteSettingsFeatures[]> => {
  const res = await axios.get<SiteSettingsFeatures[]>(`/ewosapi/v1/site-settings/${globalCompanyId}/sites-status`);
  return res.data;
};

// // GET
// /ewosapi/v1/site-settings/{globalSiteId}
export const getSiteSettings = async (globalSiteId: string): Promise<SiteSettings> => {
  const res = await axios.get<SiteSettings>(`/ewosapi/v1/site-settings/${globalSiteId}`);
  return res.data;
};

// GET
// /ewosapi/v1/site-settings/{globalCompanyId}/sites
export const getSites = async (globalCompanyId: string): Promise<Site[]> => {
  const res = await axios.get<Site[]>(`/ewosapi/v1/site-settings/${globalCompanyId}/sites`);
  return res.data;
};

// GET
// /ewosapi/v1/site-settings/{globalSiteId}/features
export const getFeatures = async (globalSiteId: string): Promise<SiteSettingsFeatures> => {
  const res = await axios.get<SiteSettingsFeatures>(`/ewosapi/v1/site-settings/${globalSiteId}/features`);
  return res.data;
};

// GET
// /ewosapi/v1/site-settings/overview
export const getSiteSettingsOverview = async (globalCompanyId: string): Promise<SitesOverviewList> => {
  // if (!isProductionEnvironment && !isStageEnvironment) return siteSettingsOverviewMock;
  const res = await axios.get<SitesOverviewList>(`/ewosapi/v1/site-settings/overview?globalCompanyId=${globalCompanyId}`);
  return res.data;
};
